import { ReactNode } from 'react';
import clsx from 'clsx';
import IconInfo from 'src/assets/images/icons/info-warning-circle.svg';
import { useFormFieldContext } from 'src/presentations/components/organisms/forms/FormFieldContext';

// eslint-disable-next-line react-refresh/only-export-components
export enum EActionDetailNotice {
  RECURRING,
  OTHER,
  NONE,
}

interface NoticeContainerProps {
  text: ReactNode;
  className?: string;
}

export const NoticeContainer = ({ text, className }: NoticeContainerProps) => (
  <div className={clsx('mt-16 xl:mt-20 px-14 xl:px-18 py-6 xl:py-8 rounded-full flex items-center gap-8 xl:gap-10 bg-[#FEF3E5]', className)}>
    <img src={IconInfo} alt='' />

    <div className='flex-1 !text-12 xl:!text-14 text-[#D97A06]'>{text}</div>
  </div>
);

export const ActionDetailNotice = () => {
  const { showUCTNotice } = useFormFieldContext();

  switch (showUCTNotice) {
    case EActionDetailNotice.RECURRING:
      return (
        <NoticeContainer
          text='This new charge will be added to the existing rate card/rate cards for the duration of the expected period of recurrence selected below. This will
        trigger a recalculation of deviations for unresolved invoices that have this charge.'
        />
      );
    case EActionDetailNotice.OTHER:
      return (
        <NoticeContainer
          text='This action will ask you to map this new charge to an existing rate card charge. This assignment will trigger a recalculation of deviations for unresolved
      invoices that have this charge.'
        />
      );
    case EActionDetailNotice.NONE:
    default:
      return null;
  }
};
